import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { SeeAllButtonClickedEventSchema } from '../../schemas/buttonClickEvents/SeeAllButtonClickedsEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { BUTTON_NAME, BUTTON_TYPE } from '../../constants/EventHelper'

export interface SeeAllClickEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  BUTTON_NAME: string
  BUTTON_TYPE: string
}

export class SeeAllButtonClickedEvent extends AnalyticsEvent {
  constructor(params: SeeAllClickEventParams) {
    super(SeeAllButtonClickedEventSchema(), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackSeeAllButtonClickedEvent(
  seeAllButtonClickParams: SeeAllClickEventParams
): Promise<void> {
  try {
    const config = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_THREE) || {}
    const { isEnabled = false } = config
    if (isEnabled) {
      const commonProperties = getCommonParams()
      const params: SeeAllClickEventParams = {
        ...commonProperties,
        ...seeAllButtonClickParams,
      }
      params.BUTTON_NAME = BUTTON_NAME.SWIMLANE_SEE_ALL
      params.BUTTON_TYPE = BUTTON_TYPE.LINK_STYLE
      new SeeAllButtonClickedEvent(params).track()
    }
  } catch (error) {
    console.error('Error tracking See All Button Clicked Event:', error)
  }
}
